import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import type { PnidGraph } from 'features/knowledgeDocumentViewer/graph/graphIndex'
import {
  type GraphScope,
  loadPageGraph,
} from 'features/knowledgeDocumentViewer/graph/loadPageGraph'
import { postFetcher } from 'features/rolodex/fetchers'
import useSWR from 'swr'

type PnidGraphKey = [string, string, string, GraphScope]
export function usePageGraph(
  pageId: string | undefined,
  documentId: string | undefined,
  scope: GraphScope | undefined,
  enabled: boolean
): {
  graph: PnidGraph | undefined
  isLoading: boolean
  error: Error | undefined
  retry: () => void
} {
  const { ROLODEX_URL } = useRuntimeVariables()
  const { authorizedAxios, isAuthenticated } = useGeckoAuth()
  const endpoint = `${ROLODEX_URL}/api/v2/entries/load`
  const key: PnidGraphKey | null =
    enabled && isAuthenticated && pageId && documentId && scope
      ? [endpoint, documentId, pageId, scope]
      : null
  const { data, error, isLoading, mutate } = useSWR<
    PnidGraph,
    Error,
    PnidGraphKey | null
  >(
    key,
    ([url, , id, currentScope]) =>
      loadPageGraph(id, currentScope, (query) =>
        postFetcher(url, JSON.stringify(query), authorizedAxios)
      ),
    { keepPreviousData: false, revalidateOnFocus: false, errorRetryCount: 2 }
  )
  return {
    graph: key ? data : undefined,
    isLoading: key !== null && isLoading,
    error: key ? error : undefined,
    retry: (): void => {
      void mutate()
    },
  }
}
